(function () {

  const init = () => {

    const containers = document.querySelectorAll(
      '.drawer--header .drawer__body, .sliderule__panel'
    );

    const update = (container) => {
      if (!container) return;

      const items = container.querySelectorAll('.sliderow, .navlink');
      const hint = container.querySelector('.scroll-hint');

      const hasMoreThan4 = items.length > 4;

      // =====================
      // SCROLLBAR CONTROL
      // =====================
      if (hasMoreThan4) {
        container.classList.add('has-scrollbar');
        container.style.overflowY = 'scroll';
      } else {
        container.classList.remove('has-scrollbar');
        container.style.overflowY = 'hidden';
      }

      // =====================
      // SCROLL HINT CONTROL
      // =====================
      if (hint) {
        const { scrollTop } = container;

        if (hasMoreThan4 && scrollTop < 10) {
          hint.classList.add('is-visible');
        } else {
          hint.classList.remove('is-visible');
        }
      }
    };

    const updateAll = () => {
      containers.forEach(container => {
        update(container);
      });
    };

    // Scroll listener
    containers.forEach(container => {
      container.addEventListener('scroll', () => update(container), { passive: true });
    });

    // Mutation observer (Shopify dynamic content)
    const observer = new MutationObserver(updateAll);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', updateAll);

    setTimeout(updateAll, 300);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();